import {AuthErrorNames} from '@/services';

/** Detects Cognito AliasExistsException (phone/email already registered). Resilient to wrapped errors. */
export function isAliasExistsException(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as {name?: string; message?: string};
  return (
    e.name === AuthErrorNames.AliasExistsException ||
    Boolean(e.message?.includes?.('phone_number already exists')) ||
    Boolean(e.message?.includes?.('already exists'))
  );
}

/** Detects Cognito ConfirmSignInAfterSignUpException (user already confirmed). Resilient to wrapped errors. */
export function isConfirmSignInAfterSignUpException(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const e = error as {name?: string; message?: string};
  return (
    Boolean(
      e.message?.includes?.(
        'User cannot be confirmed. Current status is CONFIRMED',
      ),
    ) ||
    Boolean(
      e.message?.includes?.('challengeResponse is required to confirmSignIn'),
    )
  );
}
